import { offsetDateToUtc } from '@assess/shared/entities';

import { dateFormatDefaultWith24HourTime } from '../constants/date-formats';
import { FormatDateUtcPipe } from '../pipes/format-date-utc.pipe';

const formatDateUtc = new FormatDateUtcPipe();

export function transformDateToUtc(date: string | Date) {
  const dateObj = offsetDateToUtc(date);

  return formatDateUtc.transform(dateObj, dateFormatDefaultWith24HourTime);
}
